// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3W-uy","checkboxCol":"Table_checkboxCol__3UalO","emailCol":"Table_emailCol__2hDkt","actionCol":"Table_actionCol__2_Ye8"};